import React from 'react';

import { useIntl } from 'react-intl';

import { LinkIconButton } from '@atlaskit/button/new';

import { MsTeamsIcon } from '../../../../../common/constants/icons/ms-teams';
import { SlackIcon } from '../../../../../common/constants/icons/slack';
import { type ExternalMessageIntegration } from '../../../../../common/types/social-signals';

import { messages } from './messages';

interface ExternalMessageIntegrationButtonProps {
	integrationInfo: ExternalMessageIntegration;
}

export const ExternalMessageIntegrationButton = ({
	integrationInfo,
}: ExternalMessageIntegrationButtonProps): React.JSX.Element => {
	const { integration, openDmUrl } = integrationInfo;
	const { formatMessage } = useIntl();

	return (
		<LinkIconButton
			target="_blank"
			rel="noopener noreferrer"
			href={openDmUrl}
			icon={integration === 'ms-teams' ? MsTeamsIcon : SlackIcon}
			label={formatMessage(messages.openDmButtonLabel)}
			isTooltipDisabled={false}
		/>
	);
};
